// Design tokens for the redesigned Federation CMS.
// Ported from the Claude Design handoff (warm-coral palette, slate neutrals).
// Kept as a plain JS object so both inline styles and makeStyles can consume it.

const TOKENS = {
  // Brand
  coral: '#E87B5C',
  coralDark: '#C8553A',
  coralSoft: 'rgba(232, 123, 92, 0.12)',
  coralBorder: 'rgba(232, 123, 92, 0.28)',
  blue: '#4F8BD6',
  amber: '#F1B14E',

  // Surfaces — warm neutrals
  surface: '#FAF8F5',
  surface2: '#F2EEE9',
  surface3: '#E6E0D8',
  border: '#ECE6DD',
  borderStrong: '#D9D1C5',
  white: '#FFFFFF',

  // Text
  text: '#1F1B18',
  text2: '#4A433D',
  text3: '#8B8278',

  // Semantic
  success: '#10B981',
  danger: '#C8553A',
  dangerSoft: 'rgba(200, 85, 58, 0.1)',

  // Status palettes (live / upcoming / past)
  liveBg: '#ECFDF5',
  liveText: '#047857',
  liveBorder: '#A7F3D0',
  liveDot: '#10B981',
  upcomingBg: '#FFFBEB',
  upcomingText: '#92400E',
  upcomingBorder: '#FDE68A',
  upcomingDot: '#F59E0B',
  pastBg: '#F1F5F9',
  pastText: '#475569',
  pastBorder: '#E2E8F0',
  pastDot: '#94A3B8',

  font: "'Plus Jakarta Sans', 'Roboto', system-ui, -apple-system, sans-serif",
  mono: "'JetBrains Mono', 'Roboto Mono', ui-monospace, monospace",

  radius: 12,
  radiusSm: 8,
  radiusLg: 14,
}

// Deterministic avatar colour from a name (replaces the design's per-team colour,
// which the backend doesn't provide).
const AVATAR_COLORS = [
  '#E87B5C', '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
  '#8B5CF6', '#F472B6', '#0EA5E9', '#84CC16', '#06B6D4',
  '#D946EF', '#F97316', '#22C55E', '#A855F7', '#14B8A6', '#EAB308',
]

export const avatarColor = (str = '') => {
  let hash = 0
  for (let i = 0; i < str.length; i += 1) hash = (hash * 31 + str.charCodeAt(i)) >>> 0
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}

export default TOKENS
